
import { IFormSections } from "@/interfaces/iForm";
import { defineComponent, ref, toRef, watch } from "vue";
import DiscardConfirmationModal from "@/views/formBuilder/components/DiscardConfirmationModal.vue";
import { TranslationService } from "@/core/services/TranslationService";
export default defineComponent({
  name: "designer-toolbar",
  components: {
    DiscardConfirmationModal,
  },
  props: {
    designCreated: Boolean,
    formSection: {
      type: Object as () => IFormSections,
      required: false,
    },
    isTemplate: Boolean,
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
  },
  setup(props) {
    const t = (key: string) => {
      return TranslationService.translate(key);
    };
    const controls = [];

    const showDetailDialog = ref<any>(false);
    const setAsTemplate = toRef(props, "isTemplate");
    const isTemp = ref(false);
    const publishButton = ref<HTMLButtonElement | null>(null);
    const createTableBtn = ref<HTMLButtonElement | null>(null);
    watch(
      setAsTemplate,
      (newValue) => {
        isTemp.value = newValue;
      },
      { deep: true }
    );
    watch(
      toRef(props, "loading"),
      (newValue) => {
        if (newValue) {
          publishButton.value?.setAttribute("data-kt-indicator", "on");
          createTableBtn.value?.setAttribute("data-kt-indicator", "on");
        } else {
          publishButton.value?.removeAttribute("data-kt-indicator");
          createTableBtn.value?.removeAttribute("data-kt-indicator");
        }
      },
      { deep: true }
    );
    return {
      controls,
      isTemp,
      t,
      publishButton,
      createTableBtn,
      showDetailDialog,
    };
  },
});
